import { FC, useEffect, useState } from 'react';
import { some, values } from 'lodash';
import { DateTime, DurationObjectUnits } from 'luxon';
import styles from './CbCountdownTimer.module.css';
export interface CbCountdownTimerProps {
  countdownTo: string;
  countdownFrom?: string;
  isCompleted?: boolean;
  omitSeconds?: boolean;
}
export const CbCountdownTimer: FC<CbCountdownTimerProps> = ({
  countdownTo,
  countdownFrom = DateTime.now().toISO(),
  isCompleted = false,
  omitSeconds = true
}) => {
  const unitsUntilCountdownTo = () => DateTime.fromISO(countdownTo).diff(DateTime.fromISO(countdownFrom), ['days', 'hours', 'minutes', 'seconds', 'milliseconds']).toObject();
  const [units, setUnits] = useState<DurationObjectUnits>(unitsUntilCountdownTo());
  const [hasExpired, setHasExpired] = useState<boolean>(isCompleted);
  const [intervalId, setIntervalId] = useState<number>();
  const onTick = () => setUnits(unitsUntilCountdownTo());
  useEffect(() => {
    const id = window.setInterval(onTick, omitSeconds ? 60000 : 1000);
    setIntervalId(id);
    return () => window.clearInterval(id);
  }, []);
  useEffect(() => {
    if (some(values(units), v => v as number < 0)) {
      setHasExpired(true);
      window.clearInterval(intervalId);
    }
  }, [units]);
  const {
    days,
    hours,
    minutes,
    seconds
  } = units;
  if (hasExpired) return <div className={styles.container}>
        <div className={styles.expired}>Game ended</div>
      </div>;
  return <div className={styles.container} data-sentry-component="CbCountdownTimer" data-sentry-source-file="CbCountdownTimer.tsx">
      <div className={styles.gameEndsIn}>Game ends in</div>
      <div className={styles.timerContainer}>
        <div className={styles.number}>
          <div className={styles.value} data-testid="days">
            {days}
          </div>
          <div className={styles.label}>Days</div>
        </div>
        <div className={styles.number}>
          <div className={styles.value} data-testid="hours">
            {hours}
          </div>
          <div className={styles.label}>Hrs</div>
        </div>
        <div className={styles.colon}>:</div>
        <div className={styles.number}>
          <div className={styles.value} data-testid="minutes">
            {minutes}
          </div>
          <div className={styles.label}>Mins</div>
        </div>
        {!omitSeconds && <>
            <div className={styles.colon}>:</div>
            <div className={styles.number}>
              <div className={styles.value} data-testid="seconds">
                {seconds}
              </div>
              <div className={styles.label}>Secs</div>
            </div>
          </>}
      </div>
    </div>;
};